import { Moment } from 'moment';
import { UploadFile } from 'antd/lib/upload/interface';
import { PageRequest } from '@/core/request/PageRequest';
import { Company } from '../Companies/Companies.types';
import {
  GenderTypes,
  LegalPersonContactFormInterface,
} from '@/components/_common/MultipleContactModal/types';
import { ContactType } from '../../_shared/ContactType';

export type EmployeeGender = 'Masculino' | 'Feminino';
export interface EmployeeReduced {
  name: string;
  id: number;
}
export interface Employee {
  active: boolean;
  birthday: string;
  code: string;
  companies: Company[];
  cpf: string;
  ctps: string;
  gender: EmployeeGender;
  id: number;
  name: string;
  nis: string;
  photo: string;
  pis: string;
  rg: string;
  professionalInformation: EmployeeProfessional;
  redirectKey: string;
}

export interface EmployeeInfo {
  gender?: EmployeeGender;
  id: number;
  name: string;
  photo?: string;
}

export interface ListEmployeesQuery extends PageRequest {
  search?: string;
  isActive?: boolean;
  companyId?: number;
  estimator?: boolean;
  function?: string;
  registry?: string;
  hasUser?: boolean;
}

export interface EmployeeReduced {
  function: string;
  gender: EmployeeGender;
  id: number;
  name: string;
  photo: string;
  registry: string;
}

export interface ListEmployeesQueryReduced extends PageRequest {
  name?: string;
  companyId?: number;
  estimator?: boolean;
  hasUser?: boolean;
  isActive?: boolean;
}

export interface EmployeeEditRequest {
  active: boolean;
  birthday?: string;
  code?: string;
  companiesIds: number[];
  cpf: string;
  ctps?: string;
  gender?: string;
  id: number;
  matrixId?: number;
  name: string;
  nis?: string;
  photo?: string;
  pis?: string;
  rg?: string;
}

export interface EmployeeIsEstimator {
  isEstimator: boolean;
}

export type EmployeeEditFormValues = Omit<
  EmployeeEditRequest,
  'birthday' | 'photo'
> & {
  birthday?: Moment;
  photo?: UploadFile[] | null;
  redirectKey?: string;
};

export type EmployeeContactDetail = {
  active: boolean;
  contactType: ContactType;
  description: string;
  employeeContactId: number;
  id: number;
  value: string;
};

export type EmployeeContact = {
  birthDate: string;
  department: string;
  detailList: EmployeeContactDetail[];
  email: string;
  employeeId: number;
  gender: GenderTypes;
  id: number;
  name: string;
  receiveEmail: boolean;
};

export type EmployeeAddress = {
  cityId: number;
  complement?: string;
  district: string;
  employeeId: number;
  id: number;
  latitude?: number;
  longitude?: number;
  number: string;
  street: string;
  zip: string;
};

export type EmployeeProfessionalType = 'ADMINISTRATIVE' | 'PRODUCTIVE';

export enum EmployeeProfessionalTypes {
  Administrative = 'ADMINISTRATIVE',
  Productive = 'PRODUCTIVE',
}

export enum EmployeeProfessionalAcademics {
  medioCompleto = 'Ensino Médio Completo',
  medioIncompleto = 'Ensino Médio Incompleto',
  superiorCompleto = 'Ensino Superior Completo',
  superiorIncompleto = 'Ensino Superior Incompleto',
  posCompleto = 'Pós-Graduação Completo',
  posInompleto = 'Pós-Graduação Incompleto',
  mestradoCompleto = 'Mestrado Completo',
  mestradoIncompleto = 'Mestrado Incompleto',
  completePrimaryEducation = 'Ensino Fundamental Completo',
  incompletePrimaryEducation = 'Ensino Fundamental Incompleto',
}

export type EmployeeProfessional = {
  academicLevel: string;
  admissionDate?: Date;
  area: number;
  busLines: string;
  employeeId: number;
  estimator: boolean;
  function?: {
    id: number;
    name?: number;
  };
  id: number;
  observation: string;
  partCommission: number;
  pisNumber: string;
  registry: string;
  salary: number;
  serviceCommission: number;
  ticketPrice: number;
  type: EmployeeProfessionalType;
  workCard: string;
  vehicleCode?: string;
};

export type EmployeeProfessionalFormValues = Omit<
  EmployeeProfessional,
  'admissionDate' | 'function'
> & {
  functionId?: number;
  admissionDate: Moment;
};

export type EmployeeProfessionalCreate = EmployeeProfessional;

export type EmployeeContactCreate = Omit<
  LegalPersonContactFormInterface,
  'birthDate'
> & { employeeId: number; birthDate?: string };

export type EmployeeContactEdit = EmployeeContactCreate & { id: number };
